module.exports = __webpack_public_path__ + "img/hpbd-ribbon.29047637.svg";